import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const LanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const lang = translate.currentLang || translate.getDefaultLang() || 'ca';

  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': lang,
    },
  });

  return next(modifiedReq);
};
